import * as React from 'react';
import { X, CheckSquare, XSquare } from 'react-feather';
import { useTransition } from 'react-spring';
import { Container, Message, Button, Content, Life } from './StyledElements';
import { H4 } from '../../typography';

let id = 0;

export type Intent = 'SUCCESS' | 'ERROR' | undefined;

type Props = {
  text: any;
  intent?: Intent;
};

function NotificationHub({
  config,
  timeout,
  children,
  intent = 'SUCCESS',
}: {
  config: any;
  timeout: any;
  children: any;
  intent: Intent;
}) {
  const [refMap] = React.useState(() => new WeakMap());
  const [cancelMap] = React.useState(() => new WeakMap());
  const [items, setItems] = React.useState([]);
  const transitions = useTransition(items, item => item.key, {
    from: { opacity: 0, height: 0, life: '100%' },
    enter: item => async (next: any) => await next({ opacity: 1, height: refMap.get(item).offsetHeight }),
    leave: item => async (next: any, cancel: any) => {
      cancelMap.set(item, cancel);
      await next({ life: '0%' });
      await next({ opacity: 0 });
      await next({ height: 0 });
    },
    onRest: (item: any) => setItems(state => state.filter((i: any) => i.key !== item.key)),
    // @ts-ignore
    config: (_: any, state: any) => (state === 'leave' ? [{ duration: timeout }, config, config] : config),
  });
  // @ts-ignore
  React.useEffect(() => void children((msg: any) => setItems((state: any) => [...state, { key: id++, msg }])), []);
  return (
    <Container>
      {transitions.map(({ key, item, props: { life, ...style } }: { key: any; item: any; props: any }) => (
        <Message key={key} style={style}>
          <Content intent={intent} ref={(ref: any) => ref && refMap.set(item, ref)}>
            <Life style={{ right: life }} />
            {intent === 'SUCCESS' ? <CheckSquare size={20} color="white" /> : <XSquare size={20} color="white" />}
            <H4 fontWeight="lighter" ml={2}>
              {item.msg}
            </H4>
            <Button
              onClick={(e: any) => {
                e.stopPropagation();
                if (cancelMap.has(item)) {
                  cancelMap.get(item)();
                }
              }}
            >
              <X size={18} />
            </Button>
          </Content>
        </Message>
      ))}
    </Container>
  );
}

const ToastWrapper: React.FunctionComponent<Props> = ({ text, intent }) => {
  const ref: any = React.useRef(null);
  // prettier-ignore
  React.useEffect(() => {
    if (text) {
      ref.current(text);
    }
  },              [text]);
  return (
    <NotificationHub
      intent={intent}
      config={{ tension: 125, friction: 20, precision: 0.1 }}
      timeout={3500}
      children={(add: any) => (ref.current = add)}
    />
  );
};

export default ToastWrapper;



// WEBPACK FOOTER //
// ./src/components/toasts/ToastWrapper.tsx